import React from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faMinusCircle } from "@fortawesome/free-solid-svg-icons"

class ProjectEmailEntry extends React.Component{
    constructor(){
        super()
        this.state={
            value: "",
            editing: false,
            emailError: ""
        }
    }
    validate = () =>{
        if (this.state.value === ""){
            this.setState({emailError: "You have to input something!"})
            return false
        }
        else if (!this.state.value.includes("@")){
            this.setState({emailError: "You have to input a valid email!"})
            return false
        }
        else return true
    }
    componentDidMount(){
        this.props.email === "" 
        ? this.setState({
            value: "",
            editing: true
        })
        : this.setState({
            value: this.props.email
        })
    }
    handleChange = (e) =>{
        const {name, value} = e.target
        this.setState({
            [name] : value.toLowerCase(),
            emailError: ""
        })
    }
    saveEmail = (e) =>{
        e.preventDefault()
        if (this.validate()){
            this.setState({
                editing: false,
                emailError: ""
            })
            this.props.saveEmail(this.state.value, this.props.index)
        }
    }
    deleteEmail = (e) =>{
        e.preventDefault()
        this.props.deleteEmail(this.props.index)
    }
    render(){
        return(
            this.state.editing === true
            ? <div className="newEmailInput">
                <div className="newEmail">
                    <div className="inputContainer">
                        <input type="email" name="value" 
                        value={this.state.value} onChange={this.handleChange} style={{textTransform: "lowercase"}}
                        placeholder={this.state.value==="" ? "Put your friend's email here!" : this.state.value}/>
                        <div className="error">{this.state.emailError}</div>
                    </div>
                    <div className="editingOptions">
                        <button className="inviteEntryBtn" onClick={this.saveEmail}>
                            <FontAwesomeIcon icon={faCheck} />
                        </button>
                        <button className="inviteEntryBtn" onClick={this.deleteEmail}type="submit">
                                <FontAwesomeIcon icon={faMinusCircle} />
                        </button>
                    </div>
                </div>    
            </div>
            : <div className="existingEmail">
                <h5>{this.state.value}</h5>
                <div className="editingOptions">
                    <button className="inviteEntryBtn" onClick={this.deleteEmail}>
                        <FontAwesomeIcon icon={faMinusCircle} />
                    </button>
                </div>
            </div>
        )
    }
}

export default ProjectEmailEntry